import computeClassName from '../../../../utils/computeClassName';
import { Transition } from '@headlessui/react';
import PartnerSearch from './PartnerSearch';
import PartnerComparator from './PartnerComparator';
import {useNavigationBetweenPartnerFeaturesContext} from '../../ContextProvider/Navigation/BetweenPartnerFeatures';

const constants = Object.freeze({
  CLASSNAME_BASE: 'relative h-ful w-full'
});

export default function PageHome(
  {
    className = ''
  }
) {

  const {
    isPartnerSearchFeatureSelected,
    isPartnerComparatorFeatureSelected
  } = useNavigationBetweenPartnerFeaturesContext();

  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);

  return (
    <>
      <Transition className={computedClassName}
                  unmount={false}
                  show={isPartnerSearchFeatureSelected()}
                  enter="transition-opacity ease-in duration-500"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="transition ease-out duration-300"
                  leaveFrom="opacity-0"
                  leaveTo="opacity-100">
        <PartnerSearch className="__MR_HOME_SEARCH__"/>
      </Transition>
      <Transition className={computedClassName}
                  unmount={false}
                  show={isPartnerComparatorFeatureSelected()}
                  enter="transition-opacity ease-in duration-500"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-out duration-500"
                  leaveFrom="opacity-0"
                  leaveTo="opacity-100">
        <PartnerComparator className="__MR_HOME_COMPARATOR__"/>
      </Transition>
    </>
  );
}
